import React from 'react';
import {Stack, Box} from '@mui/material';
import styles from './TabContentLayout.module.scss';

interface TabContentLayoutProps {
  testID?: string;
  sidebar: React.ReactNode;
  children: React.ReactNode;
}

function TabContentLayout({
  testID = 'tab-content-layout',
  sidebar,
  children,
}: TabContentLayoutProps) {
  return (
    <Stack className={styles.container} data-testid={testID}>
      <Box className={styles.sidebar}>{sidebar}</Box>
      <Box className={styles.content}>{children}</Box>
    </Stack>
  );
}

export default TabContentLayout;
